module.exports = __webpack_public_path__ + "img/maximeb-pro.869be9d6.jpg";